

















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'BaseDropdownItem',
})
export default class BaseDropdownItem extends Vue {
  @Prop() to: { path: string; name: string };

  handleClick(event: Event) {
    this.$emit('click', event);
  }

  get componentTag(): string {
    return this.to ? 'router-link' : 'button';
  }
}
